import { GLOBAL_OBJ } from '@sentry/utils';
var WINDOW = GLOBAL_OBJ;
export { WINDOW };